/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';

import SGColumnHeader from '@usas/ui-web/components/grids/SGColumnHeader';

import { formatDate } from '@usas/ui-web/utils/DateFunctions';
import useSortableGrid from '@usas/ui-web/utils/UseSortableGrid';
import SGConstants from '@usas/ui-web/utils/SGConstants';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const GridRow = ({ preCompReg, onRegistrationClicked }) => (
  <tr>
    <td><a onClick={e => onRegistrationClicked(e, preCompReg)}>{preCompReg.locationName}</a></td>
    <td>{formatDate(preCompReg.submissionDate)}</td>
  </tr>
);

const LargeGrid = ({ data, isLoading, onRegistrationClicked }) => {
  const {
    sortableGridState,
    onColumnClicked
  } = useSortableGrid(data);

  return (
    <table className={[global.UsasTable, 'visible-lg visible-md'].join(' ')}>
      <thead>
        <tr>
          <SGColumnHeader sortableGridState={sortableGridState} columnLabel={'Pre-Competitive Location Name'} columnField={'locationName'}
            sortType={SGConstants.SORT_TYPE_ALPHABETICAL} onColumnClicked={onColumnClicked} />
          <SGColumnHeader sortableGridState={sortableGridState} columnLabel={'Submission Date'} columnField={'submissionDate'}
            sortType={SGConstants.SORT_TYPE_DATE} onColumnClicked={onColumnClicked} />
        </tr>
      </thead>
      <tbody>
        {isLoading === true
          ? <tr><td colSpan="2">Loading...</td></tr>
          : sortableGridState.sortedGridData.length > 0
            ? sortableGridState.sortedGridData.map((preCompReg, i) => <GridRow key={i} preCompReg={preCompReg} onRegistrationClicked={onRegistrationClicked} />)
            : <tr><td colSpan="2">No Pre-Competitive Registrations</td></tr>
        }
      </tbody>
    </table>
  );
};

export default LargeGrid;